import { render, staticRenderFns } from "./gj-market-select.vue?vue&type=template&id=54d52f21&scoped=true&"
import script from "./gj-market-select.vue?vue&type=script&lang=js&"
export * from "./gj-market-select.vue?vue&type=script&lang=js&"
import style0 from "./gj-market-select.vue?vue&type=style&index=0&id=54d52f21&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d52f21",
  null
  
)

export default component.exports